"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateEmail = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _config = require("../../config");

var _cachedFetch = require("../../utils/cachedFetch");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

/* eslint-disable no-console */
var validateEmail = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(email) {
    var options, response, data, item;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = {
              method: 'POST'
            }; // Cache fetched requests to avoid unnecessary (and costly) calls to the Loqate API

            _context.next = 3;
            return (0, _cachedFetch.cachedFetch)("".concat(_config.loqateEmailVerificationApi, "?Key=").concat(encodeURIComponent(_config.loqateEmailVerificationKey), "&Email=").concat(encodeURIComponent(email), "&Timeout=10000"), options)["catch"](function () {
              console.error('Email verification API error');
            });

          case 3:
            response = _context.sent;

            if (!(response && response.ok)) {
              _context.next = 18;
              break;
            }

            _context.next = 7;
            return response.json();

          case 7:
            data = _context.sent;
            item = data.Items[0];

            if (!(item.ResponseCode === 'Valid')) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", true);

          case 11:
            if (!(item.ResponseCode === 'Invalid')) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", false);

          case 13:
            if (!item.Error) {
              _context.next = 16;
              break;
            }

            console.error(item.Description);
            return _context.abrupt("return", true);

          case 16:
            console.error('Unknown error');
            return _context.abrupt("return", true);

          case 18:
            return _context.abrupt("return", true);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validateEmail(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.validateEmail = validateEmail;